import api from '../../apiConfig/apiConfig.js';
import { Post, Put, Get, Delete } from '../base/baseAjax';

function codeFun(code) {
	//数据字典
	return Get({
		url: api.googleAds.getEnumDetail,
		PathParam: { typeId: code },
	});
}

function dictFun(dict) {
	//字典通用接口
	return Get({
		url: api.googleAds[dict],
	});
}

//目标客户匹配
let getContentList = params => {
	return Post({
		url: api.googleAds.industryDetails,
		PathParam: params,
	});
};
let industryPackageAllAds = () => {
	return Post({
		url: api.googleAds.industryPackageAllAds,
		config: {
			timeout: 60000,
		},
	});
};
let postAds = params => {
	return Post({
		url: api.googleAds.industryPackageAds,
		UrlParam: params,
	});
};
let updateOfEligibilityRegulation = () => {
	return Post({
		url: api.googleAds.crmAuthGet,
		config: {
			timeout: 60000,
		},
	});
};
let mailboxScaleUpdate = () => {
	return Post({
		url: api.googleAds.crmAuthGet,
	});
};
let downloadTheReport = () => {
	return Get({
		url: api.googleAds.industryReport,
		config: {
			timeout: 60000,
			responseType: 'blob',
		},
	});
};
let downloadIndustryPackages = params => {
	return Get({
		url: api.googleAds.industryPackage,
		UrlParam: params,
		config: {
			responseType: 'blob',
		},
	});
};
//托词管理
let deleteTopic = param => {
	return Delete({
		url: api.googleAds.deleteTopic,
		PathParam: param,
		UrlParam: param,
	});
};
let postTopic = param => {
	return Post({
		url: api.googleAds.postTopic,
		bodyParam: param,
	});
};
let putTopic = param => {
	return Put({
		url: api.googleAds.putTopic,
		bodyParam: param,
	});
};
let getTopic = () => {
	return Get({
		url: api.googleAds.getTopic,
	});
};
let extension = params => {
	return Get({
		url: api.googleAds.extension,
		PathParam: params,
		config: {
			responseType: 'blob',
		},
	});
};
//获取新户上线方案详情
let details = param => {
	return Get({
		url: api.googleAds.details,
		UrlParam: param,
	});
};
// 关键词导出
let onlinePlanExcel = params => {
	return Get({
		url: api.googleAds.execl,
		PathParam: params,
		config: {
			responseType: 'blob',
		},
	});
};
let serviceDetail = param => {
	return Get({
		url: `${api.googleAds.serviceDetail}/${param}`,
	});
};

let serviceAdvertising = param => {
	return Post({
		url: api.googleAds.serviceAdvertising,
		bodyParam: param,
	});
};

let serviceInquiryConsule = param => {
	return Post({
		url: api.googleAds.serviceInquiryConsule,
		bodyParam: param,
	});
};

let editMonitoringRules = param => {
	return Post({
		url: api.googleAds.editMonitoringRules,
		bodyParam: param,
	});
};

let monitoringRuleConfig = param => {
	return Post({
		url: api.googleAds.monitoringRuleConfig,
		bodyParam: param,
	});
};

let warningTypeList = () => {
	return Post({
		url: api.googleAds.warningType,
	});
};

let updateCost = param => {
	return Put({
		url: `${api.googleAds.updateCost}/${param.id}`,
		bodyParam: param,
		config: {
			timeout: 60000,
		},
	});
};
let activeList = param => {
	return Post({
		url: api.googleAds.activeList,
		bodyParam: param,
	});
};
let inactiveList = param => {
	return Post({
		url: api.googleAds.inactiveList,
		bodyParam: param,
	});
};

let setserviceStatus = param => {
	return Put({
		url: api.googleAds.setserviceStatus,
		bodyParam: param,
	});
};
let ruleTypeList = param => {
	return Post({
		url: api.googleAds.ruleTypeList,
		bodyParam: param,
	});
};
let signSolve = param => {
	return Get({
		url: api.googleAds.signSolve,
		PathParam: param,
	});
};
let warningLog = param => {
	return Post({
		url: api.googleAds.warningLog,
		bodyParam: param,
	});
};
let warningItemList = param => {
	return Post({
		url: api.googleAds.warningItemList,
		bodyParam: param,
	});
};
let operatList = () => {
	return Get({
		url: api.googleAds.operatList,
	});
};
let modifyRemark = (path, param) => {
	return Put({
		url: api.googleAds.modifyRemark,
		bodyParam: param,
		PathParam: path,
	});
};

let budgetCost = param => {
	return Get({
		url: `${api.googleAds.budgetCost}/${param}`,
	});
};
let ruleTreeList = param => {
	return Post({
		url: api.googleAds.ruleTreeList,
		bodyParam: param,
	});
};

let searchDataView = params => {
	return Post({
		url: api.googleAds.searchDataView,
		bodyParam: params,
		config: {
			timeout: 60000,
		},
	});
};

// 单个搜索词图表
let searchTermsCharts = params => {
	return Post({
		url: api.googleAds.searchTermsCharts,
		bodyParam: params,
	});
};

// 广告报告下载
// 创建手动报告
let addManualReport = params => {
	return Post({
		url: api.googleAds.addManualReport,
		bodyParam: params,
	});
};

// 删除报告
let deleteReport = id => {
	return Post({
		url: api.googleAds.deleteReport,
		PathParam: {
			id,
		},
	});
};

// 报告详情
let getReportDetails = id => {
	return Get({
		url: api.googleAds.getReportDetails,
		PathParam: {
			id,
		},
	});
};

// 修改备注
let reportRemarkSave = ({ id, params }) => {
	return Put({
		url: api.googleAds.reportRemarkSave,
		PathParam: {
			id,
		},
		bodyParam: `${params || ' '}`,
		config: {
			headers: { 'Content-Type': 'application/json' },
		},
	});
};

// 新增下载详细记录
let reportDownloadDetail = params => {
	return Post({
		url: api.googleAds.reportDownloadDetail,
		bodyParam: params,
	});
};

// 重新生成手动报告
let regenerateReport = params => {
	return Get({
		url: api.googleAds.regenerateReport,
		PathParam: params,
	});
};

// 广告报告下载-模板
// 模板筛选列表
let templateChooseList = () => {
	return Post({
		url: api.googleAds.templateChooseList,
	});
};

// 新增模板与客户挂钩关系
let addTemplateRelation = params => {
	return Post({
		url: api.googleAds.addTemplateRelation,
		bodyParam: params,
	});
};

// 模板详情
let getTemplateDetail = params => {
	return Get({
		url: api.googleAds.getTemplateDetail,
		PathParam: params,
	});
};

// 新增or修改模板
let addReportTemplate = params => {
	return Post({
		url: api.googleAds.addReportTemplate,
		bodyParam: params,
	});
};

// 删除模板
let deleteReportTemplate = id => {
	return Post({
		url: api.googleAds.deleteReportTemplate,
		PathParam: {
			id,
		},
	});
};

// 修改模板报告配置
let reportTemplateDimension = params => {
	return Put({
		url: api.googleAds.reportTemplateDimension,
		bodyParam: params,
	});
};

// 模板报告配置详情
let templateReportDetails = params => {
	return Get({
		url: api.googleAds.templateReportDetails,
		PathParam: params,
	});
};
let searchKeyword = params => {
	return Post({
		url: api.googleAds.searchKeyword,
		bodyParam: params,
	});
};

// 获取ads账户列表
let getAdsAccountList = params => {
	return Post({
		url: api.googleAds.getAdsAccountList,
		bodyParam: params,
	});
};
// 获取广告系列列表数据
let getCampaignList = params => {
	return Post({
		url: api.googleAds.getCampaignList,
		bodyParam: params,
	});
};
// 获取广告系列基础列表数据
let getCampaignBaseList = params => {
	return Post({
		url: api.googleAds.getCampaignBaseList,
		bodyParam: params,
	});
};
// 获取广告组基础列表数据
let getAdgroupBaseList = params => {
	return Post({
		url: api.googleAds.getAdgroupBaseList,
		bodyParam: params,
	});
};
// 获取广告系列详情
let getCampaignDetail = id => {
	return Get({
		url: api.googleAds.getCampaignDetail,
		PathParam: {
			id,
		},
	});
};
// 修改广告系列状态
let getCampaignStatus = params => {
	return Post({
		url: api.googleAds.getCampaignStatus,
		bodyParam: params,
	});
};

// 获取广告组详情
let getAdgroupDetail = id => {
	return Get({
		url: api.googleAds.getAdgroupDetail,
		PathParam: {
			id,
		},
	});
};
// 修改广告组状态
let getAdgroupStatus = params => {
	return Post({
		url: api.googleAds.getAdgroupStatus,
		bodyParam: params,
	});
};

// 修改广告状态
let getAdgroupAdStatus = params => {
	return Post({
		url: api.googleAds.getAdgroupAdStatus,
		bodyParam: params,
	});
};

// 修改关键词状态
let getKeywordStatus = params => {
	return Post({
		url: api.googleAds.getKeywordStatus,
		bodyParam: params,
	});
};

// 获取当前用户自定义列列表
let getCustomfieldUserList = type => {
	return Get({
		url: api.googleAds.getCustomfieldUserList,
		PathParam: {
			type,
		},
	});
};

// 获取自定义列列表
let getCustomfieldList = type => {
	return Get({
		url: api.googleAds.getCustomfieldList,
		PathParam: {
			type,
		},
	});
};

// 添加当前用户自定义列列表
let insertCustomfieldList = params => {
	return Post({
		url: api.googleAds.insertCustomfieldList,
		bodyParam: params,
	});
};

// 添加广告系列
let addCampaign = params => {
	return Post({
		url: api.googleAds.addCampaign,
		bodyParam: params,
		config: {
			timeout: 120000,
		},
	});
};
// 添加广告组
let addAdgroup = params => {
	return Post({
		url: api.googleAds.addAdgroup,
		bodyParam: params,
		config: {
			timeout: 120000,
		},
	});
};
// 添加广告
let addAdgroupad = params => {
	return Post({
		url: api.googleAds.addAdgroupad,
		bodyParam: params,
	});
};
// 添加关键词
let addKeyword = params => {
	return Post({
		url: api.googleAds.addKeyword,
		bodyParam: params,
	});
};
// 获取关键词匹配方式
let getMatchType = () => {
	return Get({
		url: api.googleAds.getMatchType,
	});
};

// 根据链接获取产品关键词
let getKeywordProduct = params => {
	return Post({
		url: api.googleAds.getKeywordProduct,
		bodyParam: params,
	});
};
// 关键词检测
let getKeywordCheck = params => {
	return Post({
		url: api.googleAds.getKeywordCheck,
		bodyParam: params,
	});
};
// 关键词保存-历史关键词
let getKeywordHistorical = params => {
	return Post({
		url: api.googleAds.getKeywordHistorical,
		bodyParam: params,
	});
};
// 获取服务单域名
let getServiceDomain = () => {
	return Get({
		url: api.googleAds.getServiceDomain,
	});
};
// 获取设备报价
let getCampaignDevice = params => {
	return Post({
		url: api.googleAds.getCampaignDevice,
		bodyParam: params,
	});
};
// 广告系列移除状态
let getCampaignRemove = params => {
	return Post({
		url: api.googleAds.getCampaignRemove,
		bodyParam: params,
	});
};
// 广告组移除状态
let getAdgroupRemove = params => {
	return Post({
		url: api.googleAds.getAdgroupRemove,
		bodyParam: params,
	});
};
// 广告移除状态
let getAdgroupadRemove = params => {
	return Post({
		url: api.googleAds.getAdgroupadRemove,
		bodyParam: params,
	});
};

// 广告系列编辑详情
let getCampaignEditDetail = id => {
	return Get({
		url: api.googleAds.getCampaignEditDetail,
		PathParam: {
			id,
		},
	});
};
// 广告系列修改
let getCampaignUpdate = params => {
	return Post({
		url: api.googleAds.getCampaignUpdate,
		bodyParam: params,
		config: {
			timeout: 120000,
		},
	});
};
// 广告组编辑详情
let getAdgroupEditDetail = id => {
	return Get({
		url: api.googleAds.getAdgroupEditDetail,
		PathParam: {
			id,
		},
	});
};
// 广告组修改
let getAdgroupUpdate = params => {
	return Post({
		url: api.googleAds.getAdgroupUpdate,
		bodyParam: params,
		config: {
			timeout: 120000,
		},
	});
};
// 广告修改
let getAdgroupadUpdate = params => {
	return Post({
		url: api.googleAds.getAdgroupadUpdate,
		bodyParam: params,
	});
};
// 广告编辑详情
let getAdgroupadEditDetail = id => {
	return Get({
		url: api.googleAds.getAdgroupadEditDetail,
		PathParam: {
			id,
		},
	});
};

// 广告自动检测
// 广告检测结果汇总
let detectionSummary = serviceId => {
	return Get({
		url: api.googleAds.detectionSummary,
		PathParam: {
			serviceId,
		},
	});
};

// 获取广告检测配置
let getDetectionConfig = serviceId => {
	return Get({
		url: api.googleAds.getDetectionConfig,
		PathParam: {
			serviceId,
		},
		config: {
			timeout: 60000,
		},
	});
};

// 修改广告检测配置
let setDetectionConfig = params => {
	return Post({
		url: api.googleAds.setDetectionConfig,
		bodyParam: params,
	});
};

// 广告语手动检测
let manualDetection = serviceId => {
	return Put({
		url: api.googleAds.manualDetection,
		PathParam: {
			serviceId,
		},
	});
};

// 广告语替换
let detectionReplace = params => {
	return Post({
		url: api.googleAds.detectionReplace,
		bodyParam: params,
	});
};

// 广告语忽略
let detectionIgnore = params => {
	return Post({
		url: api.googleAds.detectionIgnore,
		bodyParam: params,
	});
};

// 广告语手动检测-单条API
let detectionManualSingle = id => {
	return Put({
		url: api.googleAds.detectionManualSingle,
		PathParam: {
			id,
		},
	});
};

// 广告语手动检测-单条API
let aiOptimizeSwitch = params => {
	return Put({
		url: api.googleAds.aiOptimizeSwitch,
		bodyParam: params,
	});
};

// AI关键词判定
// 执行检测任务
let keywordRunTask = (params, serviceSiteId) => {
	return Post({
		url: api.googleAds.keywordRunTask,
		bodyParam: params,
		UrlParam: {
			serviceSiteId,
		},
		config: {
			timeout: 60000,
		},
	});
};

// 获取检测任务结果
let keywordTaskData = serviceId => {
	return Get({
		url: api.googleAds.keywordTaskData,
		PathParam: {
			serviceId,
		},
		config: {
			timeout: 60000,
		},
	});
};

// 添加关键词
let addSearchKeyword = (params, serviceId) => {
	return Post({
		url: api.googleAds.addSearchKeyword,
		bodyParam: params,
		UrlParam: {
			serviceId,
		},
		config: {
			timeout: 60000,
		},
	});
};

// 排除关键词
let excludeSearchKeyword = (params, serviceId) => {
	return Post({
		url: api.googleAds.excludeSearchKeyword,
		bodyParam: params,
		UrlParam: {
			serviceId,
		},
		config: {
			timeout: 60000,
		},
	});
};

// 忽略关键词
let igonoreSearchKeyword = (params, serviceId) => {
	return Post({
		url: api.googleAds.igonoreSearchKeyword,
		bodyParam: params,
		UrlParam: {
			serviceId,
		},
		config: {
			timeout: 60000,
		},
	});
};

// 获取排除列表
let getSharedList = serviceId => {
	return Get({
		url: api.googleAds.getSharedList,
		PathParam: {
			serviceId,
		},
		config: {
			timeout: 60000,
		},
	});
};

// 账户余额匹配
// 导入Excel匹配客户余额
let balanceMatchImport = async file => {
	let body;
	let headers = {
		Authorization: `Bearer ${localStorage.getItem('Authorization')}`,
	};

	const formData = new FormData();
	formData.append('multipartFile', file);
	body = formData;

	const response = await fetch(api.googleAds.balanceMatchImport, {
		method: 'POST',
		body: body,
		headers: headers,
	});

	if (!response.ok) {
		const errorData = await response.json().catch(() => ({}));
		throw new Error(errorData.errMsg || `HTTP error! status: ${response.status}`);
	}

	return response.json();
};

export default {
	industryPackageAllAds,
	downloadIndustryPackages,
	downloadTheReport,
	mailboxScaleUpdate,
	updateOfEligibilityRegulation,
	postAds,
	getContentList,
	deleteTopic,
	postTopic,
	putTopic,
	getTopic,
	extension,
	details,
	onlinePlanExcel,
	serviceDetail,
	serviceAdvertising,
	serviceInquiryConsule,
	editMonitoringRules,
	monitoringRuleConfig,
	updateCost,
	activeList,
	inactiveList,
	warningTypeList,
	setserviceStatus,
	ruleTypeList,
	signSolve,
	warningLog,
	operatList,
	warningItemList,
	modifyRemark,
	budgetCost,
	ruleTreeList,
	searchDataView,
	searchTermsCharts,
	addManualReport,
	templateChooseList,
	deleteReport,
	addTemplateRelation,
	getTemplateDetail,
	addReportTemplate,
	deleteReportTemplate,
	getReportDetails,
	reportRemarkSave,
	reportDownloadDetail,
	reportTemplateDimension,
	templateReportDetails,
	regenerateReport,
	searchKeyword,
	getAdsAccountList,
	codeFun,
	dictFun,
	getCampaignList,
	getCampaignDetail,
	getCampaignStatus,
	getAdgroupDetail,
	getAdgroupStatus,
	getAdgroupAdStatus,
	getKeywordStatus,
	getCustomfieldUserList,
	getCustomfieldList,
	insertCustomfieldList,
	getCampaignBaseList,
	getAdgroupBaseList,
	addCampaign,
	getMatchType,
	getKeywordProduct,
	getKeywordCheck,
	getKeywordHistorical,
	getServiceDomain,
	addAdgroup,
	addAdgroupad,
	addKeyword,
	getCampaignDevice,
	getCampaignRemove,
	getAdgroupRemove,
	getAdgroupadRemove,
	getCampaignEditDetail,
	getCampaignUpdate,
	getAdgroupEditDetail,
	getAdgroupUpdate,
	getAdgroupadUpdate,
	getAdgroupadEditDetail,
	detectionSummary,
	getDetectionConfig,
	setDetectionConfig,
	manualDetection,
	detectionReplace,
	detectionIgnore,
	detectionManualSingle,
  aiOptimizeSwitch,
	keywordRunTask,
	keywordTaskData,
	addSearchKeyword,
	excludeSearchKeyword,
	igonoreSearchKeyword,
	getSharedList,
	balanceMatchImport,
};
